import useKeys from 'components/@whistleblower-admin/useKeys';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

const WhistleblowerContext = React.createContext({});

export const WhistleblowerProvider = ({ children, me }) => {
  const { publicKey, privateKey } = useKeys();
  const contextValue = useMemo(() => ({ publicKey, privateKey, me }), [publicKey, privateKey, me]);
  return (
    <WhistleblowerContext.Provider value={contextValue}>{children}</WhistleblowerContext.Provider>
  );
};

WhistleblowerProvider.propTypes = {
  children: PropTypes.node.isRequired,
  me: PropTypes.object.isRequired,
};

export const useWhistleblower = () => React.useContext(WhistleblowerContext);

export const READ = 1;
export const EDIT = 2;
export const ADMIN = 3;

export const useCanEdit = item => {
  const { me } = useWhistleblower();
  return me.permissions?.[item] >= EDIT;
};

export const useCanAdmin = item => {
  const { me } = useWhistleblower();
  return me.permissions?.[item] >= ADMIN;
};

export default WhistleblowerContext;
